export default {
  banners:[
    // imgUrl: '图片地址'， title: '标题文本', description: '描述信息', component: '跳转组件名称'
      {
        imgUrl: require('../../../assets/images/services/banner-22.jpg'),
        title: '智能制造',
        description: '',
        component: ''
      }
  ],
  items:[
    {
      title: '智能制造',
      description: `<p >十五载规划领航，数智制造筑梦！从产业筑基到创新突围，中国十五个五年规划始终锚定先进制造航向，铺就制造强国的壮阔征程。我们紧随国策步伐，将智能制造深度融入发展脉络，以 5G、AI、工业互联网为翼，打通研发、生产、供应链全链条数据壁垒。</p>
<p>在这里，数字孪生缩短产品研制周期，智能产线让生产效率跃升 33% 以上，绿色智造实现能耗大幅降低，柔性制造精准响应每一份定制需求。从车间里的智能巡检到供应链的协同共振，从关键技术攻关到产业生态共建，我们以政策为帆、以技术为桨，让 “制造” 向 “智造” 的转型落地生根，让规划蓝图转化为看得见的提质增效成果。</p>
<p>与时代同频，与国策同行，我们以智能制造之力，护航企业迈向价值链中高端，共绘先进制造的崭新篇章！</p>`
    },
    {
      title: '我们的优势',
       description: `
      <video autoplay muted loop playsinline class="advantage-video">
        <source src="https://tfile.melinked.com/2024/02/8c437d9e-7822-422c-becf-8f050d005a11.mp4" type="video/mp4">
      </video>
      <span class="list">
      <i></i>自动化程度高，生产效率显著提升。<br/>
      <i></i>数据驱动决策，提高运营精准度。<br/>
      <i></i>生产过程可视化，便于实时监控与管理。<br/>
      <i></i>设备互联，实现柔性生产和快速响应。<br/>
      <i></i>质量检测智能化，降低不良率。<br/>
      <i></i>能耗优化，实现绿色低碳生产。<br/>
      <i></i>降低人工依赖，提升整体运营稳定性。<br/>
      </span>`
    }
  ]
}
